// ForgotPassword.js
import React, { useState } from 'react';
import './ForgotPassword.css'
import { app } from '../FirebaseConfig'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';

const auth = getAuth(app);

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const handleReset = (e) => {
    e.preventDefault();
    sendPasswordResetEmail(auth, email)
    .then(() => {
        alert('Password reset email sent!');
    })
    .catch((error) => {
        const errorMessage = error.message;
        alert(errorMessage);
    });
    
  }
  return (
    <div className="forgot-password-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleReset}>
        <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
        </div>
        <button type="submit" className="reset-button">Reset Password</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
